import { useContext, useEffect, useState } from "react";
import "./index.scss";
import NavBar from "../../components/Navbarr";
import Footerr from "../../components/Footerr";
import { UserContext } from "../../components/context/userContext";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Lottie from "react-lottie";


import { calculateTotalInOrder } from "../../utils";
import ModalEditPhoto from "../../components/ModalEditPhoto";
import ModalCancelOrder from "../../components/ModalCancelOrder";
import ModalOrderDetail from "../../components/ModalOrderDetail";
import { api } from "../../config/baseApi";
import { defaultOptionsEmpty } from "../../assets/lottie-animations/animationOptions";
import { getIncommingOrders } from "../../services/get-incomming-orders";
import { getHistoryOrders } from "../../services/get-history-orders";
import { getProfileImage } from "../../services/get-profile-image";
import { CancelOrder } from "../../services/post-cancel-order";

const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
  },
  content: {
    top: "40%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: "65vh",
    minHeight: "65vh",
    borderWidth: 0,
    borderRadius: 12,
    background : "transparent"

    
  }
};

const Profile = () => {
  const { user, isAuthenticated } = useContext(UserContext);
  const navigate = useNavigate();

  const [section, setSection] = useState<"profile" | "orders">("profile");
  const [orderType, setOrderType] = useState<"incoming" | "history">("incoming");

  const [incomingOrders, setIncomingOrders] = useState<any[]>([]);
  const [historyOrders, setHistoryOrders] = useState<any[]>([]);

  const [showEditPhoto, setShowEditPhoto] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [orderToCancel, setOrderToCancel] = useState<any>(null);
  const [hasProfileImage, setHasProfileImage] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      navigate("/acceuil");
      return;
    }

    getIncommingOrders(user._id).then((r) => setIncomingOrders(r?.content || []));
    getHistoryOrders(user._id).then((r) => setHistoryOrders(r?.content || []));
    getProfileImage(user._id).then((r) => setHasProfileImage(!r?.error));
  }, [user]);

  const cancelOrder = () => {
    CancelOrder(orderToCancel?._id, user?._id)
      .then(() => {
        toast.success("Order cancelled");
          getIncommingOrders(user._id).then((r) => setIncomingOrders(r?.content || []));
    getHistoryOrders(user._id).then((r) => setHistoryOrders(r?.content || []));
        setShowCancel(false);
      })
      .catch(() => toast.error("Error cancelling order"));
  };

  return (
    <div className="profile-page">
      <NavBar page="profile" />

      <div className="profile-layout">
        {/* SIDEBAR */}
        <aside className="profile-sidebar">
          <div className="avatar-wrapper">
            <img
              src={
                hasProfileImage
                  ? `${api}/user/${user?._id}/profile-image`
                  : "/assets/defaultProfileImage.png"
              }
              alt="profile"
            />
            <button className="edit-avatar" onClick={() => setShowEditPhoto(true)}>
              <i className="bx bx-edit" />
            </button>
          </div>

          <button
            className={section === "profile" ? "active" : ""}
            onClick={() => setSection("profile")}
          >
            Mon Profil
          </button>

          <button
            className={section === "orders" ? "active" : ""}
            onClick={() => setSection("orders")}
          >
            Mes Commandes
          </button>
        </aside>

        {/* MAIN */}
        <main className="profile-main">
          {section === "profile" && (
            <div className="profile-info">
              <h2>Mon Profil</h2>
              <p><strong>Name:</strong> {user?.name}</p>
              <p><strong>Email:</strong> {user?.email}</p>
            </div>
          )}

          {section === "orders" && (
            <>
              <div className="orders-header">
                <button
                  className={orderType === "incoming" ? "active" : ""}
                  onClick={() => setOrderType("incoming")}
                >
                  En route
                </button>
                <button
                  className={orderType === "history" ? "active" : ""}
                  onClick={() => setOrderType("history")}
                >
                  Historique
                </button>
              </div>

              <div className="orders-list">
                {(orderType === "incoming" ? incomingOrders : historyOrders)
                  .length === 0 ? (
                  <Lottie options={defaultOptionsEmpty} height={200} width={200} />
                ) : (
                  (orderType === "incoming"
                    ? incomingOrders
                    : historyOrders
                  ).map((order) => (
                    <div className="order-card" key={order._id}>
                      <div className="order-date-strip">
                        <span className="day">{new Date(order.createdAt).getDate()}</span>
                        <span className="month">
                          {new Date(order.createdAt).toLocaleString("en", {
                            month: "short",
                          })}
                        </span>
                      </div>

                      <div className="order-card-content">
                        <div className="order-card-header">
                          <span className="order-id">Order #{order.transaction_id}</span>
                          <span className={`status-pill ${order.status}`}>
                            {order.status}
                          </span>
                        </div>

                        <div className="order-product-list">
                          {order.products.map((p: any, i: number) => (
                            <div className="order-product-row" key={i}>
                              <span>{p.count}×</span>
                              <span>{p.name}</span>
                              <span>{p.price} DT</span>
                            </div>
                          ))}
                        </div>

                        <div className="order-total">
                          <span>Total</span>
                          <strong>
                            {calculateTotalInOrder(order.products).toFixed(3)} DT
                          </strong>
                        </div>

                        <div className="order-actions">
                          <button
                            className="outline-btn"
                            onClick={() => {
                              setSelectedOrder(order);
                              setShowDetails(true);
                            }}
                          >
                            Détails
                          </button>

                          {orderType === "incoming" && (
                            <button
                              className="danger-btn"
                              onClick={() => {
                                setOrderToCancel(order);
                                setShowCancel(true);
                              }}
                            >
                              Annuler
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </main>
      </div>

      <Footerr />

      <Modal isOpen={showEditPhoto} style={modalStyles}>
        <ModalEditPhoto closeModal={() => setShowEditPhoto(false)}  />
      </Modal>

      <Modal isOpen={showCancel} style={modalStyles}>
        <ModalCancelOrder
          closeModalCancel={() => setShowCancel(false)}
          cancelAction={cancelOrder}
          orderToCancel={orderToCancel}
        />
      </Modal>

      <Modal isOpen={showDetails} style={modalStyles}>
        <ModalOrderDetail order={selectedOrder} closeModal={() => setShowDetails(false)} />
      </Modal>
    </div>
  );
};

export default Profile;
